export const DEFAULT_PAGE_TITLE = 'Material database';
export const DEFAULT_PAGE_DESCRIPTION = 'Web site created using create-react-app';

export function isSuitableMaterialDescription(description) {
    return description.length >= 40 && description.length <= 160
        && !/[<>]|https?:\/\//i.test(description)
        // Legacy records can contain standard Lorem Ipsum filler. Keep this
        // deliberately narrow so real material descriptions remain eligible.
        && !/\blorem\s+ipsum\b/i.test(description);
}

export function getMaterialMetadata(material) {
    const name = material?.materialName || material?.name;
    const description = typeof material?.materialDescription === 'string'
        ? material.materialDescription.replace(/\s+/g, ' ').trim() : '';
    const suitable = isSuitableMaterialDescription(description);
    return {
        title: name ? `${name} Material Properties for CNC Machining | ASiJoLab` : 'Material Details | ASiJoLab',
        description: name
            ? (suitable ? description : `Explore ${name} material properties for CNC machining, including mechanical strength or hardness, thermal conductivity, elongation and chemical composition.`)
            : 'View engineering material properties for CNC machining.',
        canonical: material?.slug ? `https://asijolab.com/materials/${encodeURIComponent(material.slug)}` : null,
        robots: material?.isChecked === true ? 'index, follow' : 'noindex, nofollow'
    };
}

export function formatMaterialValue(value, unit) {
    return value === undefined || value === null || value === '' ? 'Not available' : `${value} ${unit}`;
}

export function formatMaterialComposition(composition) {
    return Array.isArray(composition) && composition.length
        ? composition.map(item => `${item.element}: ${item.percentage}%`).join(', ')
        : 'Not available';
}
